import { Theme } from "@mui/material";
import diagonal from "./diagonal";

const themes: Record<string, Theme> = {
  default: diagonal,
  //add more custom themes here
};

export default themes;
